export default "__VITE_ASSET__84dd83d2__"